import React from "react";
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import Dialog from './ActionDialog';
import HtmlContent from "./HtmlContent";
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({ open, onConfirm, onHide, onCancel, title, confirmText, fullWidth }) => {
    const { t } = useTranslation();
    return (
        <Dialog fullWidth={fullWidth} open={open} onClose={onHide}>
            <DialogTitle>
                <Typography variant="h6" component={"span"} sx={{color: 'grey'}}>
                    <HtmlContent content={title} />
                </Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body1" color="textSecondary">
                    <HtmlContent content={confirmText} />
                </Typography>
            </DialogContent>

            <DialogActions sx={{display: 'flex', justifyContent: 'space-evenly'}}>
                <Button className="app-btn" onClick={onCancel} color="secondary" variant="contained">
                    {t('common.cancel')}
                </Button>
                <Button className="app-btn" onClick={onConfirm} color="success" variant="contained">
                    {t('common.yes')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
